import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { QueryParameters } from "@core/models/common.interface";
import { MetacomState } from "@core/models/metacom.interface";
import { StoreBranding, StoreDetailsState } from "@core/models/store.interface";
import { Store } from "@ngrx/store";
import { MetacomStatusType } from "@shared/enums";
import { metacomActions } from "@shared/store/metacom/actions";
import { storeActions } from "@shared/store/store-details/actions";
import { hasNestedEmptyValues } from "@shared/utils/objects.util";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class StartupService {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<{
      storeDetails: StoreDetailsState;
      metacom: MetacomState;
    }>
  ) {}

  fetchQueryParamtersAndUpdateStates(): Observable<MetacomStatusType> {
    return this.route.queryParams.pipe(
      take(1),
      map((params) => {
        const storeName = this.router.url.split("?")[0].replace(/^\/+/, "");

        const queryParameters: QueryParameters = {
          storeDetails: {
            storeName: storeName ?? "",
            storeBranding: this.getStoreImage(storeName),
            branch: params["branch"] ?? "",
          },
          metacomDetails: {
            mac: params["mac"] ?? "",
            ip: params["ip"] ?? "",
            status: params["status"] ?? "",
            authHash: params["authHash"] ?? "",
            authEndPoint: params["authEndPoint"] ?? "",
          },
        };

        this.store.dispatch(
          storeActions.setStoreDetails(queryParameters.storeDetails)
        );

        this.store.dispatch(
          metacomActions.setMetacomDetails(queryParameters.metacomDetails)
        );

        if (!hasNestedEmptyValues(queryParameters)) {
          return queryParameters.metacomDetails.status as MetacomStatusType;
        } else {
          return MetacomStatusType.InsufficientData;
        }
      })
    );
  }

  getStoreImage(store: string): StoreBranding {
    switch (store) {
      case "pep":
        return {
          landingImage: "assets/branding/pep_wifi.png",
          joinImage: "assets/branding/pep_wifi_join.png",
          connectedImage: "assets/branding/pep_logo_small.png",
          primaryColour: "#1180FA",
        };

      case "ackermans":
        return {
          landingImage: "assets/branding/ackermans_wifi.png",
          joinImage: "assets/branding/ackermans_wifi_join.png",
          connectedImage: "assets/branding/ackermans_logo_small.png",
          primaryColour: "#00A048",
        };

      case "dunns":
        return {
          landingImage: "assets/branding/dunns_wifi.png",
          joinImage: "assets/branding/dunns_wifi_join.png",
          connectedImage: "assets/branding/dunns_logo_small.png",
          primaryColour: "#000000",
        };

      default:
        return {} as StoreBranding;
    }
  }
}
